import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.loaded && _ctx.getPropertyBooleanValue(_ctx.BaseControlTypeConst.VISIBLE))
    ? _withDirectives((_openBlock(), _createBlock(_component_Panel, {
        key: 0,
        container: _ctx.container,
        id: _ctx.getPropertyValue(_ctx.PanelTypeConst.ID),
        style: _normalizeStyle(_ctx.getPropertyValue(_ctx.PanelTypeConst.STYLE)),
        class: _normalizeClass(_ctx.getPropertyValue(_ctx.PanelTypeConst.CLASS)),
        name: _ctx.getPropertyValue(_ctx.PanelTypeConst.NAME),
        disabled: _ctx.getPropertyValue(_ctx.PanelTypeConst.DISABLED),
        visible: _ctx.getPropertyValue(_ctx.PanelTypeConst.VISIBLE),
        placeholder: _ctx.getPropertyValue(_ctx.PanelTypeConst.PLACEHOLDER),
        header: _ctx.getPropertyValue(_ctx.PanelTypeConst.HEADER),
        toggleable: _ctx.getPropertyBooleanValue(_ctx.PanelTypeConst.TOGGLEABLE),
        collapsed: _ctx.getPropertyBooleanValue(_ctx.PanelTypeConst.COLLAPSED),
        modelValue: _ctx.vmodel,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.vmodel) = $event))
      }, {
        icons: _withCtx(() => [
          _renderSlot(_ctx.$slots, "icons")
        ]),
        header: _withCtx(() => [
          _renderSlot(_ctx.$slots, "header")
        ]),
        footer: _withCtx(() => [
          _renderSlot(_ctx.$slots, "footer")
        ]),
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "content")
        ]),
        _: 3 /* FORWARDED */
      }, 8 /* PROPS */, ["container", "id", "style", "class", "name", "disabled", "visible", "placeholder", "header", "toggleable", "collapsed", "modelValue"])), [
        [_directive_tooltip, _ctx.getPropertyValue(_ctx.PanelTypeConst.TOOLTIP)]
      ])
    : _createCommentVNode("v-if", true)
}